import { Box } from '@mui/material';
import { BalancesLayout } from 'components/Layouts/BalancesLayout';
import {
  DefaultBalance,
  DefaultBalanceWithResize,
} from 'templates/Balances/Default';
import { BalancesSectionProps } from './types';
import { formattingNumber } from 'utils/index';
import { useMemo, useState } from 'react';

const defaultBalanceQuantityFormat = {
  billionShorthand: false,
  fractionalSeparator: '.',
  milSeparator: '',
  millionShorthand: false,
  thousandShorthand: false,
};

export const DefaultBalancesSection: React.FC<BalancesSectionProps> = ({
  balances,
  balanceQuantityFormat = defaultBalanceQuantityFormat,
}) => {
  const [fontSize, setFontSize] = useState<string>('14px');
  const longestAmountDetails = useMemo(
    () =>
      balances.reduce(
        (prev, curr, index) => {
          const currLength = curr?.amount?.toString().length || 0;

          if (index === 0) return { index: 0, length: currLength };

          if (currLength > prev.length)
            return { index: index, length: currLength };
          return prev;
        },
        { index: 0, length: 0 },
      ),
    [balances],
  );

  return (
    <Box>
      <BalancesLayout>
        {balances.map((balance, index) => (
          <>
            {index === longestAmountDetails.index ? (
              <DefaultBalanceWithResize
                key={`default${index}`}
                balance={balance}
                displayAmount={
                  balance.amount
                    ? formattingNumber(balance.amount, balanceQuantityFormat)
                    : undefined
                }
                setFontSize={setFontSize}
              />
            ) : (
              <DefaultBalance
                key={`default${index}`}
                balance={balance}
                displayAmount={
                  balance.amount
                    ? formattingNumber(balance.amount, balanceQuantityFormat)
                    : undefined
                }
                fontSize={fontSize}
              />
            )}
          </>
        ))}
      </BalancesLayout>
    </Box>
  );
};
